import { useContext } from 'react'
import { AppContext } from 'app/context/AppContext'
import { useTitle } from 'react-use'

export const usePageTitle = (page) => {
  const { activeOrg } = useContext(AppContext)
  const name = activeOrg?.orgName ? `${page} - ${activeOrg.orgName}` : page
  useTitle(`${name} - Serverless Console`)
}
